import React from 'react';
import { motion } from 'framer-motion';
import { Divider } from './Divider';
export function ReassuranceSection() {
  const pairs = [{
    positive: 'Confían en Sus promesas.',
    negative: 'Pero les cuesta descansar en ellas.'
  }, {
    positive: 'Oran.',
    negative: 'Pero sienten que cargan demasiado peso sobre sus hombros.'
  }, {
    positive: 'Creen.',
    negative: "Pero muchas veces viven más pendientes de sus problemas que de la provisión y la presencia de Dios."
  }];
  return <section className="w-full bg-[#0B1A3A] py-20 px-6" style={{
    backgroundColor: "#5B401F",
    backgroundImage: "none"
  }} data-id="element-228" data-mp="2t3fmdqe1z1x7">
      <div className="max-w-3xl mx-auto text-center" data-id="element-229" data-mp="2y2a4sr83yogs">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-xl md:text-2xl text-white mb-4 uppercase tracking-wide font-semibold" data-id="element-230" data-mp="32tidtm5j07tf">
          Si te identificaste con estas palabras, quiero que sepas algo:
        </motion.p>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-3xl md:text-4xl font-bold text-[#E0B756] mb-12" data-id="element-231" data-mp="2rp1kcceycgyo">
          No eres la única persona que se siente así.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-lg text-gray-300 mb-12 leading-relaxed" style={{
        color: "#F7F2E7"
      }} data-id="element-232" data-mp="2dvk2cw1wzcar">
          Miles de creyentes aman profundamente a Dios, pero cada día luchan contra la preocupación, el estrés y la incertidumbre por el futuro.
        </motion.p>

        <div className="space-y-8 mb-12" data-id="element-233" data-mp="3tcarac0gz1h8">
          {pairs.map((pair, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="grid md:grid-cols-2 gap-4 items-center" data-id="element-234" data-mp="1rog1fpr4zfa7" data-mpi={index}>
              <p className="text-white text-lg md:text-right" data-id="element-235" data-mp="1mnsa12yzwwfg">
                {pair.positive}
              </p>
              <p className="text-gray-400 text-lg italic md:text-left" style={{
            color: "#F7F2E7"
          }} data-id="element-236" data-mp="2feseff18o27n">
                {pair.negative}
              </p>
            </motion.div>)}
        </div>

        <Divider data-id="element-237" data-mp="25gcrlo98vf3y" />

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-lg md:text-xl text-gray-300 leading-relaxed" style={{
        color: "#F7F2E7"
      }} data-id="element-238" data-mp="25fut0kz40osv">
          Y poco a poco comienzan a alejarse de aquello que más anhelan:{' '}
          <span className="text-[#E0B756] font-semibold" data-id="element-239" data-mp="hjn3qaqr4xaf">
            Una vida guiada por la paz, la confianza y una relación cercana con
            Dios.
          </span>
        </motion.p>
      </div>
    </section>;
}